// removed by extract-text-webpack-plugin
module.exports = {"container":"zcpvtBXV9OCLzpqOKgzcq"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Layout/styles.css
// module id = 2585
// module chunks = 0